import React from 'react';
import { Grid, Card, Group, Text, RingProgress, ThemeIcon, Title } from '@mantine/core';
import { IconCheck, IconClock, IconAlertTriangle, IconListDetails } from '@tabler/icons-react';
import { StatisticsSummaryTypes } from '../../../types/statistics-types';

interface StatisticsSummaryProps {
  summary: StatisticsSummaryTypes;
}

export function StatisticsSummary({ summary }: StatisticsSummaryProps) {
  // Calcola le percentuali
  const requestCompletionPercentage = summary.totalRequests > 0 
    ? Math.round((summary.completedRequests / summary.totalRequests) * 100) 
    : 0;
  
  const taskCompletionPercentage = summary.totalTasks > 0 
    ? Math.round((summary.completedTasks / summary.totalTasks) * 100) 
    : 0;
  
  const pendingRequestsPercentage = summary.totalRequests > 0 
    ? Math.round((summary.pendingRequests / summary.totalRequests) * 100) 
    : 0;
  
  const overduePercentage = summary.totalRequests > 0 
    ? Math.round((summary.overdueRequests / summary.totalRequests) * 100) 
    : 0;
  
  return (
    <Grid gutter="md">
      <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
        <Card withBorder p="md" radius="md">
          <Group justify="apart">
            <div>
              <Text size="xs" c="dimmed">
                Completamento richieste
              </Text>
              <Title order={3}>{requestCompletionPercentage}%</Title>
              <Text size="xs" c="dimmed" mt={6}>
                {summary.completedRequests} di {summary.totalRequests} richieste completate
              </Text>
            </div>
            <RingProgress
              size={80}
              roundCaps
              thickness={8}
              sections={[{ value: requestCompletionPercentage, color: 'blue' }]}
              label={
                <ThemeIcon color="blue" variant="light" radius="xl" size={40}>
                  <IconCheck size={20} />
                </ThemeIcon>
              }
            />
          </Group>
        </Card>
      </Grid.Col>
      
      <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
        <Card withBorder p="md" radius="md">
          <Group justify="apart">
            <div>
              <Text size="xs" c="dimmed">
                Richieste in attesa
              </Text>
              <Title order={3}>{pendingRequestsPercentage}%</Title>
              <Text size="xs" c="dimmed" mt={6}>
                {summary.pendingRequests} di {summary.totalRequests} richieste in corso
              </Text>
            </div>
            <RingProgress
              size={80}
              roundCaps
              thickness={8}
              sections={[{ value: pendingRequestsPercentage, color: 'yellow' }]}
              label={
                <ThemeIcon color="yellow" variant="light" radius="xl" size={40}>
                  <IconClock size={20} />
                </ThemeIcon>
              }
            />
          </Group>
        </Card>
      </Grid.Col>
      
      <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
        <Card withBorder p="md" radius="md">
          <Group justify="apart">
            <div>
              <Text size="xs" c="dimmed">
                Richieste in ritardo
              </Text>
              <Title order={3}>{overduePercentage}%</Title>
              <Text size="xs" c="dimmed" mt={6}>
                {summary.overdueRequests} di {summary.totalRequests} richieste in ritardo
              </Text>
            </div>
            <RingProgress
              size={80}
              roundCaps
              thickness={8}
              sections={[{ value: overduePercentage, color: 'red' }]}
              label={
                <ThemeIcon color="red" variant="light" radius="xl" size={40}>
                  <IconAlertTriangle size={20} />
                </ThemeIcon>
              }
            />
          </Group>
        </Card>
      </Grid.Col>
      
      <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
        <Card withBorder p="md" radius="md">
          <Group justify="apart">
            <div>
              <Text size="xs" c="dimmed">
                Completamento task
              </Text>
              <Title order={3}>{taskCompletionPercentage}%</Title>
              <Text size="xs" c="dimmed" mt={6}>
                {summary.completedTasks} di {summary.totalTasks} task completati
              </Text>
            </div>
            <RingProgress
              size={80}
              roundCaps
              thickness={8}
              sections={[{ value: taskCompletionPercentage, color: 'green' }]}
              label={
                <ThemeIcon color="green" variant="light" radius="xl" size={40}>
                  <IconListDetails size={20} />
                </ThemeIcon>
              }
            />
          </Group>
        </Card>
      </Grid.Col>
      
      <Grid.Col span={12}>
        <Grid>
          <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
            <Card withBorder p="md">
              <Text size="sm" color="dimmed">Tempo medio di completamento richieste</Text>
              <Title order={3}>{summary.avgCompletionTime.toFixed(1)} giorni</Title>
            </Card>
          </Grid.Col>
          
          <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
            <Card withBorder p="md">
              <Text size="sm" color="dimmed">Totale task in corso</Text>
              <Title order={3}>{summary.inProgressTasks}</Title>
            </Card>
          </Grid.Col>
          
          <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
            <Card withBorder p="md">
              <Text size="sm" color="dimmed">Task in ritardo</Text>
              <Title order={3}>{summary.overdueTasks}</Title>
            </Card>
          </Grid.Col>
          
          <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
            <Card withBorder p="md">
              <Text size="sm" color="dimmed">Totale task</Text>
              <Title order={3}>{summary.totalTasks}</Title>
            </Card>
          </Grid.Col>
        </Grid>
      </Grid.Col>
    </Grid>
  );
}